import '../../../../../../util/styles/index.js';
import { useAdsStyles } from '../../../../../../util/styles/hooks/useAdsStyles.js';

var useIconContent = function useIconContent(props) {
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;

  // Initially, the mask position was set to `center center`, which is a reasonable value for our case - we want icon
  // to be centered in the end, although technically it will always fill the container as it's a square icon in a
  // square container. But `center center` causes the icon to move up and down by one pixel in different parts of the
  // screen in Safari even when the same size and configuration is used. So, we use `left top` instead to have
  // consistent visuals.
  var maskProp = "url(\"".concat(props.url, "\") left top / contain no-repeat");
  return {
    style: props.loaded ? undefined : mapAdsStyles({
      display: 'inline-flex'
    }),
    svg: mapAdsStyles({
      width: props.iconSize,
      height: props.iconSize,
      transform: props.flip ? 'scaleX(-1)' : undefined,
      mask: maskProp,
      fill: props.fill === 'inherit' ? undefined : props.fill
    }),
    image: props.loaded ? undefined : {
      style: mapAdsStyles({
        display: 'none'
      }),
      url: props.url,
      onLoad: props.onLoad,
      onError: props.onLoadingError
    }
  };
};

export { useIconContent };
//# sourceMappingURL=useIconContent.js.map
